import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { enableRestrictedAssetVisibility } from '@api/assetVisibility';

import { IId } from '@interfaces/common/common';
import { IOrganizationId } from '@interfaces/common/defaultDTO';

import { EUserRoles } from '@enums/common';

import {
	ASSET_VISIBILITY,
	ASSET_VISIBILITY_RESTRICTED,
	ASSET_VISIBILITY_RESTRICTED_ENABLE,
} from '@constants/queryKeys';

interface IUseMutateEnableAssetVisibilityReturned {
	enableAssetVisibility: UseMutateFunction<any, any, IId & Partial<IOrganizationId>, any>;
	isLoadingEnableAssetVisibility: boolean;
}

export const useMutateEnableAssetVisibility = (): IUseMutateEnableAssetVisibilityReturned => {
	const queryClient = useQueryClient();

	const {
		mutate,
		isLoading,
	} = useMutation<IId & Partial<IOrganizationId>>({
		mutationKey: [ASSET_VISIBILITY_RESTRICTED_ENABLE],
		allowedRoles: [
			EUserRoles.platformOwnerAdministrator,
			EUserRoles.assetOwnerOrganizationAdministrator,
		],
		mutationFn: enableRestrictedAssetVisibility,
		onSuccess: () => {
			return [
				queryClient.invalidateQueries([ASSET_VISIBILITY_RESTRICTED]),
				queryClient.invalidateQueries([ASSET_VISIBILITY]),
			];
		},
	});

	return {
		enableAssetVisibility: mutate,
		isLoadingEnableAssetVisibility: isLoading,
	};
};
